import { useCallback } from "react";
import { SSH_Role } from "@danishagro/sharedShop/src/interfaces/role.interface";
import { SSH_Scope } from "@danishagro/sharedShop/src/interfaces/scope.interface";
import { SSH_ScopeGroup } from "@danishagro/sharedShop/src/interfaces/scopeGroup.interface";
import { FetchOptions } from "@danishagro/shared/src/interfaces/fetchOptions.interface";
import { useRequest } from "@danishagro/shared/src/hooks/useRequest.hook";

type GetRoles = (options?: FetchOptions) => Promise<SSH_Role[]>;
type GetScopes = (options?: FetchOptions) => Promise<SSH_Scope[]>;
type GetScopeGroups = (options?: FetchOptions) => Promise<SSH_ScopeGroup[]>;

export const useRolesApi = () => {
    const request = useRequest();

    const getRoles: GetRoles = useCallback(
        (options?) => request.get(`api/role/roles`, null, options),
        [request]
    );

    const getScopeGroups: GetScopeGroups = useCallback(
        (options?) => request.get(`api/role/groups`, null, options),
        [request]
    );

    const getScopes: GetScopes = useCallback(
        (options?) => request.get(`api/role/rights`, null, options),
        [request]
    );

    return {
        getRoles,
        getScopeGroups,
        getScopes,
    };
};
